import { render, staticRenderFns } from "./AffiliateServiceList.vue?vue&type=template&id=005198c8&"
import script from "./AffiliateServiceList.vue?vue&type=script&lang=js&"
export * from "./AffiliateServiceList.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateServiceList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports